import React, { Component } from "react";
import { find } from "lodash";
import { Alert } from "react-bootstrap";
import DesignTool from "../../designtool";
import {URL_PURCHASE, RING_COLOR_DEFAULT, EARRINGS_TYPE_ID, TYPE_NEXT_PURCHASE, URL_SAVE_DESIGN} from "../../const";
import ModalLimitDesign from "../Modal/ModalLimitDesign";

const uuid = require("uuid/v4");
export default class ButtonPurchase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenWindow: false,
      isShowAlert: false,
      dataResponse: {},
      errorMsg: ""
    };
  }

  showAlertError(msg) {
    this.setState({
      errorMsg: msg,
      isShowAlert: true
    });
  }

  handlePurchase() {
    let items = DesignTool.getItems();
    let {
      handleUpdateState,
      designInfo,
      paramUrl,
      ringIdActive,
      tmpDesignInfo,
      isKeepData
    } = this.props;
    let products = [];
    let listDesign = JSON.parse(localStorage.getItem("products")) || [];
    // Check ring
    if (
      designInfo.ringId === 0
      // (tmpDesignInfo.ringId !== 0 && !isKeepData)
    ) {
      handleUpdateState("isShowDialogMessage", true);
      handleUpdateState(
        "dialogMessage",
        "商品をデザインする前に基本素材を選択してください。"
      );

      return;
    }

    // Check item
    if (items.length === 0) {
      handleUpdateState("isShowDialogMessage", true);
      handleUpdateState("dialogMessage", "素材を選択してください。");

      return;
    }

    // Check count design
    // if (listDesign.length >= 15) {
    //   handleUpdateState('typeNextAction', TYPE_NEXT_PURCHASE);
    //   handleUpdateState("isShowModalLimitDesign", true);
    //   return;
    // }

    // Reset tmp design
    handleUpdateState("tmpDesignInfo", {
      ringId: 0,
      ringSize: null,
      ringSizeMin:null,
      ringSizeMax:null,
      ringColor: "",
      ringPrice: 0,
      ringColorCode: RING_COLOR_DEFAULT
    });
    handleUpdateState("tmpListItem", []);
    handleUpdateState("tmpRingIdActive", 0);
    handleUpdateState("isKeepData", false);

    if (items.length > 0) {
      items.map(item => {
        let product = {
          product_id: item.productID,
          size_id: item.sizeID,
          angle: item.angle,
          radius: null,
        };
        products.push(product);
      });
    }

    handleUpdateState("isLoadingPage", true);
    let image = DesignTool.getPNGBase64();
    let number_image = DesignTool.getPNGBase64(true);
    let object = {};
    let typeButtonSave = this.props.typeButtonSave;
    let url = (typeButtonSave==TYPE_NEXT_PURCHASE) ? URL_PURCHASE : URL_SAVE_DESIGN;
    if(ringIdActive!=EARRINGS_TYPE_ID){
      object = {
        image: image,
        number_image: number_image,
        type: ringIdActive,
        ring_id: designInfo.ringId,
        products: products,
        ring_min_size:DesignTool.circleView.ringSizeMin,
        ring_size: designInfo.ringSize,
        ring_max_size:DesignTool.circleView.ringSizeMax,
        ring_color: designInfo.ringColor,
        ring_color_code: designInfo.ringColorCode,
        order_made_id: paramUrl.orderMadeId,
      };
    }
    else
    {
      object = {
        image: image,
        number_image: number_image,
        type: ringIdActive,
        ring_id: designInfo.ringId,
        products: products,
        ring_size: designInfo.ringSize,
        ring_color: designInfo.ringColor,
        ring_color_code: designInfo.ringColorCode,
        order_made_id: paramUrl.orderMadeId,
      };
    }
    fetch(url, {
      method: "POST",
      body: JSON.stringify(object)
    })
      .then(response => response.json())
      .then(data => {
        this.setState({
          dataResponse: data || {},
          isOpenWindow: true
        });
        handleUpdateState("isLoadingPage", false);
      });
  }

  checkErrorPurchase(response) {
    let { productList } = this.props;
    let msg = "";

    switch (response.error_code) {
      case 100:
        msg = "パラメータが無効です。";
        break;
      case 101:
        msg = "デザインの保存は失敗しました。";
        break;
      case 102:
        msg = "ベースが正しくありません。";
        break;
      case 103:
        msg = "画像はbase 64でなければなりません。";
        break;
      case 104:
        let errorMsg = "";
        if (response.data.sizes.length > 0) {
          let idex = 0;
          for (var i = 0; i < response.data.sizes.length; i++) {
            let errorSize = response.data.sizes[i];
            let stoneName = "";
            let sizeName = "";

            for (var j = 0; j < productList.length; j++) {
              let siz = find(productList[j].sizes, function(s) {
                return s.id === errorSize.id;
              });

              if (siz !== undefined) {
                idex++;
                let comma = " mm ";
                if (response.data.sizes.length > 1) {
                  comma = " mm, ";
                }
                if (idex === response.data.sizes.length) {
                  comma = " mm ";
                }
                sizeName = " サイズ " + siz.size + comma;
                stoneName = productList[j].name;

                errorMsg += stoneName + sizeName;
                break;
              }
            }
          }
        }
        msg += errorMsg + " は在庫が切れました";
        break;
      case 105:
        msg = "この基本素材がなくなりました。他の基本素材を選択してください。";
        break;
      case 106:
        msg = "すみませんが、いくつかの商品は販売が停止されました。";
        break;
      case 404:
        msg = "見つかりません。";
        break;
      default:
        msg = "";
        break;
    }

    return msg;
  }

  handleSaveDesign() {
    let { designInfo, ringIdActive,  paramUrl} = this.props;
    let options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "Asia/Tokyo"
    };
    let curentTime = new Date();

    var itemRingSizeMin = designInfo.ringSize;
    var itemRingSizeMax = designInfo.ringSize;
    if(designInfo.ringTypeId!=EARRINGS_TYPE_ID){
        if(designInfo.ringSizeMin) itemRingSizeMin=designInfo.ringSizeMin;
        if(designInfo.ringSizeMax) itemRingSizeMax=designInfo.ringSizeMax;
    }


    // Save design
    let designList = JSON.parse(localStorage.getItem("products")) || [];
    let image = DesignTool.getPNGBase64();
    let items = DesignTool.getItems();
    let id = uuid();
    let product = {
      id: id,
      name: `「${curentTime.toLocaleDateString(
        "ja-JP",
        options
      )}」 に作成したデザイン`,
      image: image,
      items: items,
      ringSize: designInfo.ringSize,
      ringSizeMin: itemRingSizeMin,
      ringSizeMax: itemRingSizeMax,
      ringPrice: designInfo.ringPrice,
      ringId: designInfo.ringId,
      ringColor: designInfo.ringColor,
      ringColorCode: designInfo.ringColorCode,
      ringTypeId: ringIdActive,
      orderMadeId: paramUrl.orderMadeId,
    };

    designList.push(product);
    localStorage.setItem("products", JSON.stringify(designList));
  }

  render() {
    let { isOpenWindow, dataResponse, isShowAlert, errorMsg } = this.state;
    let { handleUpdateState } = this.props;
    let { typeButtonSave } = this.props;

    if (isOpenWindow) {
      if (dataResponse.error_code === 0) {
        // this.handleSaveDesign();
        window.open(dataResponse.data.url, "_blank");
      } else {
        this.showAlertError(this.checkErrorPurchase(dataResponse));
      }

      this.setState({ isOpenWindow: false });
    }

    if (isShowAlert) {
      handleUpdateState("isShowDialogMessage", true);
      handleUpdateState("dialogMessage", errorMsg);
      this.setState({ isShowAlert: false });
    }

    if(typeButtonSave == TYPE_NEXT_PURCHASE){
      return (
          <button className="btn_cart" onClick={() => this.handlePurchase()}>
            <img className="show_cart_new" src="/img/cart_new.png" alt="" />
            <span>カートに入れる</span>
          </button>
      );
    }else{
      return (
          <button className="btn_stock" onClick={() => this.handlePurchase()}>
            <img className="show_stock_new" src="/img/stock_new.png" alt="" />
            <span>デザインを保存</span>
          </button>
      );
    }

  }
}
